// FE mirror of the calendar subgraph's Hire-role sets
// (services/calendar/functions/src/graphql/roles.ts). The string literals match
// the `Access.role` value on the authenticated user. One source of truth for
// useInterviewGuidePermissions — keep in sync with the backend if roles change.

/** Internal Hire role values (mirror backend `Role`). */
export const HireRole = {
  owner: "owner",
  admin: "admin",
  user: "user", // Recruitment Manager
  editor: "editor",
  hiringManager: "hiringManager",
  viewer: "viewer", // Reviewer (read-only)
} as const;
export type HireRole = (typeof HireRole)[keyof typeof HireRole];

/** Full guide authority — the backend "managers only" set. */
export const MANAGER_ROLES: readonly string[] = [
  HireRole.owner,
  HireRole.admin,
  HireRole.user,
];

/** Managers + Hiring Manager (add a bank question; AI refine/draft previews). */
export const MANAGER_OR_HM_ROLES: readonly string[] = [
  ...MANAGER_ROLES,
  HireRole.hiringManager,
];

/** Attach/detach a guide on an interview — everyone except viewers. */
export const ASSIGN_ROLES: readonly string[] = [
  ...MANAGER_OR_HM_ROLES,
  HireRole.editor,
];

/** May view the guides list + question bank — everyone except viewers. */
export const VIEW_GUIDE_ROLES: readonly string[] = ASSIGN_ROLES;
